import {
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { DEFAULT_TITLE_OPTS, titleWithNameUI } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['applicants--remarriage-title'];
const INPUT_LABEL = content['applicants--remarriage-label'];

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.applicant),
    applicantRemarried: yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['applicantRemarried'],
    properties: {
      applicantRemarried: yesNoSchema,
    },
  },
};
